import { ApiConfig } from '@/types';

export const config: ApiConfig = {
  // Unsplash API配置 (主要)
  unsplash: {
    apiKey: import.meta.env.VITE_UNSPLASH_API_KEY || 'Lfv6gn_XEbcoKRq5lJTu99QH5nSVi_JYbEkUuw4jNLc',
    baseUrl: 'https://api.unsplash.com',
    defaultQueries: [
      'nature landscape',
      'mountain scenery', 
      'ocean sunset',
      'forest morning',
      'desert dunes',
      'northern lights',
      'autumn leaves',
      'winter snow'
    ],
    orientation: 'landscape',
    useHotlinking: true
  },
  
  // Pexels API配置 (备用)
  pexels: {
    apiKey: import.meta.env.VITE_PEXELS_API_KEY || 'kNVIruEdmFyTeRgifADRZKjyk6bNOTOszUwssSMhFlFCk4mQhQkYdRrI',
    baseUrl: 'https://api.pexels.com/v1',
    defaultQueries: ['nature', 'landscape', 'mountains', 'ocean', 'forest', 'sunset', 'flowers'],
    orientation: 'landscape',
    size: 'large'
  },
  
  // 一言API配置
  hitokoto: {
    baseUrl: 'https://v1.hitokoto.cn',
    fallbackUrls: [
      'https://api.hitokoto.cn',
      'https://hitokoto.api.haydns.top'
    ],
    types: ['i', 'd'], // i: 诗词, d: 文学
  },
  
  // 缓存配置
  cache: {
    duration: 24 * 60 * 60 * 1000, // 24小时
    key: 'daily_quote_cache_react'
  },
  
  // 图片API选择
  imageProvider: 'unsplash'
};

// 音乐播放器配置
export const MUSIC_CONFIG = {
  // 使用原版的 Spotify 播放列表
  spotify: {
    url: 'https://open.spotify.com/embed/playlist/37i9dQZF1DX3Ogo9pFvBkY?utm_source=generator&theme=0&autoplay=1',
    fallbackUrl: 'https://open.spotify.com/embed/playlist/37i9dQZF1DWWcIjGpzHaVv?utm_source=generator&theme=0&autoplay=1' // 备用白噪音播放列表
  },
  // YouTube Music 备选方案 - 白噪音和自然声音
  youtube: {
    url: 'https://www.youtube.com/embed/watch?v=nDq6TstdEi8&autoplay=1&loop=1&controls=1', // 著名的白噪音视频
    fallbackUrl: 'https://www.youtube.com/embed/watch?v=ZXsQAXx_ao0&autoplay=1&loop=1&controls=1' // 雨声白噪音
  },
  // 本地音频文件选项（如果有的话）
  local: {
    enabled: false,
    files: [
      '/audio/white-noise.mp3',
      '/audio/rain-sounds.mp3',
      '/audio/forest-sounds.mp3'
    ]
  },
  // 当前使用的播放器类型
  provider: 'youtube' as 'spotify' | 'youtube' | 'local'
};

// 应用元数据
export const APP_META = {
  title: '每日一签 - 诗词与远方',
  description: '精致的日签网站，每天展示诗词配上优美的背景图片',
  version: '2.0.0',
  author: 'Daily Quote Team'
};